import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {ErrorService} from '~/app/core/services/error.service';
import {BehaviorSubject, Observable, lastValueFrom} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Template} from '@model/Template';
import {Store} from '@model/Store';
import {BaseService} from "~/app/core/services/base.service";

const TEMPLATE_PREVIEW = '/template/preview/'; // GET /template/preview/{hoId}/{chain}/{store}/{action}
const TEMPLATE_APPLY = '/template/apply/'; //{hoId}  (PUT)

@Injectable({
  providedIn: 'root'
})
export class TemplateCopyService {

  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };

  public hoId: string = '';
  public chain: string = '';
  public storeId: string = '';
  public userId: string = '';

  private selectedTemplateStoreSource = new BehaviorSubject<Store>(new Store());
  selectedTemplateStore = this.selectedTemplateStoreSource.asObservable();

  private selectedTargetStoreSource = new BehaviorSubject<Store>(new Store());
  selectedTargetStore = this.selectedTargetStoreSource.asObservable();


  private targetSegmentMapSource = new BehaviorSubject<Map<number, string>>(new Map());
  targetSegmentMap = this.targetSegmentMapSource.asObservable();

  private templateSegmentMapSource = new BehaviorSubject<Map<number, string>>(new Map());
  templateSegmentMap = this.templateSegmentMapSource.asObservable();


  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService) {
  }

  changeSelectedTemplateStore(store: Store) {
    this.selectedTemplateStoreSource.next(store);
  }

  changeSelectedTargetStore(store: Store) {
    this.selectedTargetStoreSource.next(store);
  }

  changeTargetSegmentMap(map: Map<number, string>) {
    this.targetSegmentMapSource.next(map);
  }

  changeTemplateSegmentMap(map: Map<number, string>) {
    this.templateSegmentMapSource.next(map);
  }

  async preview(action: string, chain: string, hoId: string, store: string, targetSegmentMap: Map<number, String>, templateSegmentMap: Map<number, String>,) {
    const templateEntries = Array.from(templateSegmentMap.entries()).sort();
    const targetEntries = Array.from(targetSegmentMap.entries()).sort();

    let arrTemp = [];
    let arrTarg = [];

    for (const [key, value] of templateEntries) {
      arrTemp.push(value);
    }

    for (const [key, value] of targetEntries) {
      arrTarg.push(value);
    }

    var json = {
      sourceSegments: arrTemp,
      targetSegments: arrTarg
    };

    this.hoId = hoId;
    this.storeId = store;
    this.chain = chain;
    console.warn(this.configuration.RESTURL + TEMPLATE_PREVIEW + hoId + '/' + chain + '/' + store + '/' + action);
    const results = await lastValueFrom(this.baseService.postHttpObjectArrayNoOptions(
      'preview',
      'template-copy-service',
      this.configuration.RESTURL + TEMPLATE_PREVIEW + hoId + '/' + chain + '/' + store + '/' + action, json))
      .catch(this.errorService.handleError('template-copy.service preview(' + hoId + ')', []));
    return results as Template[];
  }


  apply(chain: string, storeId: string, storeConfig: any): Observable<any> {
    var array = [];
    array.push({'chain': chain, 'store': storeId, 'glCodeList': storeConfig});

    console.warn(this.configuration.RESTURL + TEMPLATE_APPLY + this.hoId + JSON.stringify(array[0]));
    return this.baseService.putHttpObject<any>(
      'apply',
      'template-copy-service',
      this.configuration.RESTURL + TEMPLATE_APPLY + this.hoId, JSON.stringify(array[0]), this.httpOptions)
      .pipe(
        tap(_ => console.log('updating template copy...: ' + array)),
        catchError(this.errorService.handleError('template-copy.service  apply', array))
      );
  }

  private serializeModels(data?: any): string {
    if (data instanceof Object) {
      return `${JSON.stringify([data])}`;
    } else {
      return data;
    }
  }
}

